import { EitriApp } from "../../models-v2/EitriApp";

import AxiosService from "../../services/axios-service/AxiosService";
import ErrorHandler from "../../utils/ErrorHandler";
import Storage from "../storage/Storage";

const MANAGER_API_URL = process.env.REACT_APP_MANAGER_API;

export class EitriAppService {
    static async getEitriApps(
        limit: number,
        page: number
    ): Promise<EitriApp[]> {
        let token, config;
        let params = {};
        let organizationData;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
            organizationData = Storage.get(Storage.KEYS.ORGANIZATION_DATA);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        if (organizationData) {
            const orgData = JSON.parse(organizationData);
            params = { organizationId: orgData.id };
            let custumParams = {};
            if (page) {
                custumParams = {
                    ...params,
                    ...{ limit, page }
                };
            } else {
                custumParams = {
                    ...params,
                    ...{ limit }
                };
            }

            config = {
                headers: {
                    Authorization: "Bearer " + token
                },
                params: custumParams
            };

            const url = MANAGER_API_URL + "/eitri-apps";
            const resp = await AxiosService.httpGet(url, config);
            return resp.data;
        }
        throw new Error("Não foi possível recuperar os Eitri Apps");
    }

    static async getEitriAppById(id: string): Promise<EitriApp> {
        let token, config;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        config = {
            headers: {
                Authorization: "Bearer " + token
            }
        };

        const url = MANAGER_API_URL + `/eitri-apps/${id}`;
        const resp = await AxiosService.httpGet(url, config);
        return resp.data;
    }

    static async updateEitriAppById(eitriApp: EitriApp): Promise<EitriApp> {
        let token, config;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        config = {
            headers: {
                Authorization: "Bearer " + token
            }
        };

        const url = MANAGER_API_URL + "/eitri-apps";
        const resp = await AxiosService.httpPut(url, eitriApp, config);
        return resp.data;
    }

    static async getEitriAppsByName(
        limit: number,
        page: number,
        name: string
    ): Promise<EitriApp[]> {
        let token, config;
        let params = {};
        let organizationData;
        try {
            token = Storage.get(Storage.KEYS.USERTOKEN);
            organizationData = Storage.get(Storage.KEYS.ORGANIZATION_DATA);
        } catch (error) {
            ErrorHandler.handleError(error);
        }

        if (organizationData) {
            const orgData = JSON.parse(organizationData);

            params = {
                organizationId: orgData.id,
                searchValue: name,
                filter: "name"
            };
            let custumParams = {};
            if (page) {
                custumParams = {
                    ...params,
                    ...{ limit, page }
                };
            } else {
                custumParams = {
                    ...params,
                    ...{ limit }
                };
            }

            config = {
                headers: {
                    Authorization: "Bearer " + token
                },
                params: custumParams
            };

            const url = MANAGER_API_URL + "/eitri-apps";
            const resp = await AxiosService.httpGet(url, config);
            return resp.data;
        }
        throw new Error("Não foi possível recuperar os Eitri Apps");
    }
}
